// Desc: initial state for pcb fabrication including data when return from cart
import _ from "lodash";

import defaultState from "./defaultState";
import { PRICE_SELECTED, QUOTED } from "../../../shared/pu-data/QuoteSteps";

const state = _.cloneDeep(defaultState);

if (Spree.fabrication) {
  const { quote, quote_parameters } = Spree.fabrication;
  state.quantitiesChanged = true;
  state.lineItemId = Spree.fabrication.line_item_id;
  state.quote = quote;
  state.parameters = Object.assign({}, state.parameters, quote_parameters);

  if (quote_parameters.quote_config_key) {
    state.quoteStep = PRICE_SELECTED;
  } else {
    state.quoteStep = QUOTED;
  }
} else if (Spree.assembly) {
  // If the project doesn't include fabrication, but includes assembly take parameters from assembly
  const { part_number, revision, filename } = Spree.assembly.quote_parameters;

  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = filename;
} else if (Spree.stencils && Spree.stencils.length > 0) {
  // If the project doesn't include fabrication, but includes stencils take parameters from stencils
  const { parameters: stencilParameters } = Spree.stencils[0];
  let { part_number: partNumber, revision, filename } = stencilParameters;
  if (partNumber.endsWith("-Top Side")) {
    partNumber = partNumber.replace("-Top Side", "");
  } else if (partNumber.endsWith("-Bottom Side")) {
    partNumber = partNumber.replace("-Bottom Side", "");
  } else if (partNumber.endsWith("-Combine Top & Bottom")) {
    partNumber = partNumber.replace("-Combine Top & Bottom", "");
  }
  state.parameters.part_number = partNumber;
  state.parameters.revision = revision;
  state.parameters.filename = filename;
} else if (Spree.parts) {
  // If the project doesn't include fabrication, but includes parts take parameters from parts
  const { part_number, revision, zip_file } = Spree.parts;
  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = zip_file;
}

export default state;
